module.exports = __webpack_public_path__ + "static/media/YuPin.46665537.jpg";